import { Injectable, isDevMode } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {
  isDevMode(): boolean {
    return isDevMode();
  }
}
